import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import FieldInput from '../../../../common/components/FieldInput';
import Spinner from '../../../../common/components/Spinner';
import format from './formatters';
import styles from './styles.module.scss';

const FORM_FIELDS = [
  {
    id: 'gush',
    label: 'גוש',
    className: `${styles.size25} ${styles.offset12right}`,
  },
  {
    id: 'helka',
    label: 'חלקה',
    className: styles.size25,
  },
  {
    id: 'ttHelka',
    label: 'תת חלקה',
    className: `${styles.size25} ${styles.offset12left}`,
  },
  {
    id: 'address',
    label: 'כתובת',
    className: `${styles.size75} ${styles.offset25BothSides}`,
  },
  {
    id: 'officialDate',
    label: 'המועד הקובע',
    format: format.date,
    className: `${styles.size25} ${styles.offset12right}`,
  },
  {
    id: 'registeredArea',
    label: 'שטח חלקה רשום',
    className: styles.size25,
  },
  {
    id: 'houseRegisteredArea',
    label: 'שטח רשום',
    className: `${styles.size25} ${styles.offset12left}`,
  },
  {
    id: 'houseRoomCount',
    label: 'מספר חדרים',
    className: `${styles.size25} ${styles.offset12right}`,
  },
  {
    id: 'floor',
    label: 'קומה',
    format: format.reversSign,
    className: styles.size25,
  },
  {
    id: 'buildingFloorsCount',
    label: 'מספר קומות',
    className: `${styles.size25} ${styles.offset12left}`,
  },
  {
    id: 'buildingAge',
    label: 'גיל הבניין',
    className: `${styles.size25} ${styles.offset12right}`,
  },
  {
    id: 'houseParking',
    label: 'חניה',
    format: format.bool,
    className: styles.size25,
  },
  {
    id: 'buildingElevator',
    label: 'מעלית',
    format: format.bool,
    className: `${styles.size25} ${styles.offset12left}`,
  },
  {
    id: 'houseYard',
    label: 'חצר',
    format: format.bool,
    className: `${styles.size25} ${styles.offset12right}`,
  },
  {
    id: 'houseStorage',
    label: 'מחסן',
    format: format.bool,
    className: styles.size25,
  },
  {
    id: 'houseRoof',
    label: 'גג',
    format: format.bool,
    className: `${styles.size25} ${styles.offset12left}`,
  },
  {
    id: 'price',
    label: 'אומדן שווי',
    format: format.priceIntegerDivided,
    className: `${styles.size50} ${styles.offset50left}`,
  },
];

const InfoPanel = ({
                     shumaId,
                     getShumaBasicData,
                     showGlobalErrorMessage,
                     closeModal
                   }) => {
  const [basicData, setBasicData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => getShumaBasicData({shumaId}))
      .then(setBasicData)
      .catch(err => showGlobalErrorMessage(err.message))
      .finally(() => setLoading(false));
  }, [shumaId]);

  const renderBasicData = () => {
    return FORM_FIELDS.map((field, index) => {
      const {id, label, format, className} = field;
      const value = format ? format(basicData[id]) : basicData[id];
      return (
        <div className={`${styles.field} ${className}`}>
          <FieldInput
            fieldId={field}
            value={value}
            label={label}
            disabled
            containerCustomStyles={styles.widerField}
          />
        </div>
      )
    })
  };

  return loading
    ? <Spinner/>
    : (
      <Form className={styles.container}>
        {basicData && renderBasicData()}
        <div className={styles.buttonContainer}>
          <button
            type="button"
            className={styles.buttonCancel}
            onClick={closeModal}
          >
            <span>סגירה</span>
          </button>
        </div>
      </Form>
    );
};

InfoPanel.propTypes = {
  shumaId: PropTypes.number,
  getShumaBasicData: PropTypes.func,
  showGlobalErrorMessage: PropTypes.func,
  closeModal: PropTypes.func,
};

export default InfoPanel;
